<template>
    <v-app>
        <v-app-bar app dark clipped-left>
            <v-app-bar-nav-icon @click.stop="mini = !mini" v-if="isAuthenticated"></v-app-bar-nav-icon>
            <v-btn text class="logo d-none d-lg-flex d-xl-flex d-md-flex">
                <span class="mr-2">{{$t('message.ufv')}}</span>
            </v-btn>            
            <v-spacer></v-spacer>
            <Cart v-if="numProductsCart>0"></Cart>
            <v-btn text to="login" v-if="!isAuthenticated">
                <span class="mr-2">{{$t('message.login')}}</span>
                <v-icon>mdi-account</v-icon>
            </v-btn>            
            <v-menu offset-y v-if="isAuthenticated">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-account</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-avatar>
                        <v-icon>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                        <v-list-item-title>{{$t('message.welcome')}}</v-list-item-title>
                        <v-list-item-subtitle>{{currentUser}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item
                        v-for="(item, i) in userItems"
                        :key="i"
                        :to="item.path">
                    <v-list-item-title>
                        <v-list-item-title >{{$t('message.'+item.title)}}</v-list-item-title>
                    </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>            
        </v-app-bar>
        <v-navigation-drawer
            app
            clipped
            v-model="drawer"
            :permanent="true"
            :mini-variant.sync="mini"            
            v-if=isAuthenticated>    
            <v-list>
                <v-list-item-group>
                    <v-list-item
                        v-for="(item, i) in sideItems"
                        :key="i"
                        :to="item.path"
                        @click.stop="mini ? true: false">
                    <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <v-list-item-title >{{$t('message.'+item.title)}}</v-list-item-title>
                    </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <v-container fluid>                
                <router-view></router-view>
            </v-container>
        </v-main>
        <v-footer app dark>
            <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
    </v-app>
</template>

<script>
    import Cart  from  './components/cart/Cart';
    export default {
        name: "App",
        components: { Cart },
        data: () => ({
            drawer: false,
            mini: true,
            sideItems: [
                { title: "home",  icon: "mdi-clipboard-list", path: "/"},
                { title: "cards", icon: "mdi-clipboard-list", path: "/cards" },
                { title: "store", icon: "mdi-basket-outline", path: "/store" },
                { title: "about", icon: "mdi-information", path: "/about" },               
            ],
            userItems: [
                { title: "profile", path: "/profile" },
                { title: "orders",  path: "/orders" },
                { title: "logout",  path: "/logout" }
            ]
        }),
        methods: { },
        computed: {
            isAuthenticated: function(){
                return this.$store.getters.isAuthenticated;
            },
            currentUser: function(){
                return this.$store.state.auth.username;
            },
            numProductsCart(){
                return this.$store.getters.numProductsCart;
            }
        },
        watch: {
            group() {
                this.drawer = false;
            }
        }
    };
</script>

<style>
    .logo.theme--dark.v-btn--active::before,
    .logo.theme--dark.v-btn--active:hover::before {  opacity: 0; }
    .card-search-input{
        margin-top: 45px;
    }
</style>